module.exports = __webpack_public_path__ + "static/media/Maf_09Abril.f49a54c9.jpg";